import {Component, OnInit, ViewChild} from '@angular/core';
import {IdentStatus} from '../../../dto/ident-status';
import {PrevNextModel} from '../../../models/prev-next-model';
import {RoleService} from '../../../services/role.service';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {DatePipe} from '@angular/common';
import {ObjectCommentsService} from '../../services/object-comment.service';
import {EventLogService} from '../../../services/crud/event-log.service';
import {MatDialog} from '@angular/material/dialog';
import {toDateTimeString} from '../../../providers/app-date-adapter';
import {PartnerWallet} from '../../../dto/partnerWallet';
import {Company} from '../../../dto/company';
import {PartnerWalletService} from '../../../partner-wallet.service';
import {getTableFilters} from '../../../helpers/storage-helper';
import {PartnerWalletTransaction} from '../../../dto/partnerWalletTransaction';
import {LoadDialogComponent} from '../load-dialog/load-dialog.component';
import {PartnerWalletLoadModel} from '../../../models/partner-wallet-load-model';
import {
  UploadPartnerLoadsFileDialogComponent
} from '../upload-partner-loads-file-dialog/upload-partner-loads-file-dialog.component';
import {
  UploadLoadsFileResultsDialogComponent
} from '../upload-loads-file-results-dialog/upload-loads-file-results-dialog.component';
import {ToastService} from 'angular-toastify';
import {BalanceAdjustmentDialogComponent} from '../balance-adjustment-dialog/balance-adjustment-dialog.component';
import {TransferFundsDialogComponent} from '../transfer-funds-dialog/transfer-funds-dialog.component';
import {
  PartnerWalletDownloadStatementModel,
  PartnerWalletTransferFundsModel
} from '../../../models/partner-wallet-transfer-funds-model';
import {DownloadStatementDialogComponent} from '../download-statement-dialog/download-statement-dialog.component';
import {FileHelper} from '../../../helpers/file-helper';
import {EditWalletDialogComponent} from '../edit-wallet-dialog/edit-wallet-dialog.component';
import {
  UploadLoadDocumentsDialogComponent
} from '../upload-load-documents-dialog/upload-load-documents-dialog.component';
import {ConfirmDialogComponent} from '../../../shared/confirm-dialog/confirm-dialog.component';
import {MultiCrudDataSource, ReadOnlyDataSource} from '../../../table-datasouces/multi-crud.datasource';
import {MatTableGeneratorComponent} from '../../../shared/mat-table-generator/mat-table-generator.component';
import {AppUser} from '../../../dto/app-user';
import {AppUserPartnerWalletAccessSlim} from '../../../dto/app-user-partner-wallet-access-slim';
import {InviteWalletUserDialogComponent} from '../invite-wallet-user-dialog/invite-wallet-user-dialog.component';

import {Observable} from 'rxjs';
import {DataListModel} from '../../../models/data-list-model';
import {ContentRowField} from '../../../shared/content-row/content-row.component';
import {LoadInfo} from "../../../dto/loadInfo";

@Component({
  selector: 'app-wallet-view',
  templateUrl: './wallet-view.component.html',
  styleUrls: ['./wallet-view.component.css']
})
export class WalletViewComponent implements OnInit {


  constructor(
    private _toastService: ToastService,
    private roleService: RoleService,
    private partnerWalletService: PartnerWalletService,
    private router: Router,
    private route: ActivatedRoute,
    public datePipe: DatePipe,
    private objectCommentsService: ObjectCommentsService,
    private logService: EventLogService,
    private dialog: MatDialog,
  ) {
  }
  public partnerWallet: PartnerWallet | null;
  public walletLoadInfo: LoadInfo | null;
  private partnerWalletId: number | null;

  webIdTransactionStatus = IdentStatus;

  prevNext: PrevNextModel;

  company: Company | null;

  private busyPollerInterval: ReturnType<typeof setTimeout> | null;
  isBusy = false;
  public transactions: PartnerWalletTransaction[];
  public pendingCardLoads: PartnerWalletLoadModel[];

  @ViewChild(MatTableGeneratorComponent, { static: true }) transactionsTable: MatTableGeneratorComponent;

  transactionsDataSource = new MultiCrudDataSource(this.partnerWalletService, {
    getManyOverride: (
      pageIndex, pageSize, sortField, sortDirection, filterString, dateFilterCols, startFilterDate, endFilterDate, someAdditionalData, additionalFilterData, enumFilter, companiesFilter) => {
      const fs = this.partnerWalletService.getTransactions(
        this.partnerWalletId,
        pageIndex,
        pageSize,
        sortField,
        sortDirection,
        filterString,
        dateFilterCols,
        startFilterDate,
        endFilterDate,
        someAdditionalData
      );
      return fs;
    }
  });

  fieldsCompany = [
    {header: 'Name', cell: (row: Company) => `${row.name}`} as ContentRowField<Company>,
    {header: 'Brand Name', cell: (row: Company) => `${row.brandName || ''}`},
    {header: 'Director name', cell: (row: Company) => `${row.directorFirstName || ''} ${row.directorName || ''}`},
    {header: 'Director job title', cell: (row: Company) => `${row.directorJobTitle || ''}`},
    {header: 'Phone', cell: (row: Company) => `${row.phone || ''}`},
    {header: 'Email', cell: (row: Company) => `${row.email || ''}`},
    {header: 'Website URL', isExternalLink: (row: Company) => `${row.websiteUrl || ''}`, link: (row: Company) => `${row.websiteUrl || ''}`, cell: (row: Company) => `${row.websiteUrl || ''}`},
    {header: 'Support Email', cell: (row: Company) => `${row.supportEmail || ''}`},
    {header: 'Support Phone', cell: (row: Company) => `${row.supportPhone || ''}`},
    {header: 'Country', cell: (row: Company) => `${row.countryName || ''}`},
    {header: 'City', cell: (row: Company) => `${row.city || ''}`},
    {header: 'Address', cell: (row: Company) => `${row.address || ''}`},
    {header: 'Postcode', cell: (row: Company) => `${row.postcode || ''}`},
    {header: 'VAT reg nr', cell: (row: Company) => `${row.vatRegNr || ''}`},
    {header: 'VAT rate', cell: (row: Company) => `${row.vatRate || ''}`},

  ] as ContentRowField<Company>[];

  transactionsColumns = [
    {
      columnDef: 'createDate',
      header: 'Created',
      cell: (row: PartnerWalletTransaction) => `${toDateTimeString(row.transactionDate) || ''}`
    },
    {columnDef: 'amount', header: 'Amount', cell: (row: PartnerWalletTransaction) => `${row.amount.formatMoneyCcy(this.partnerWallet.currencyCode)}`},
    {columnDef: 'fee', header: 'Fee', cell: (row: PartnerWalletTransaction) => `${row.fee.formatMoneyCcy(this.partnerWallet.currencyCode)}`},

    {columnDef: 'balanceBefore', header: 'Before', cell: (row: PartnerWalletTransaction) => `${row.balanceBefore.formatMoneyCcy(this.partnerWallet.currencyCode)}`},
    {columnDef: 'balanceAfter', header: 'After', cell: (row: PartnerWalletTransaction) => `${row.balanceAfter.formatMoneyCcy(this.partnerWallet.currencyCode)}`},
    {
      columnDef: 'description',
      header: 'Description',
      cell: (row: PartnerWalletTransaction) => `${row.comment || '(missing)'}`
    },


  ];

  walletUsers: AppUserPartnerWalletAccessSlim[] = [];

  isLoading = false;
  userColumns = [
    {columnDef: 'email', sortable: false, header: 'E-Mail', cell: (row: AppUserPartnerWalletAccessSlim) => `${row.appUser?.email ?? row.inviteEmail}`},
    {columnDef: 'name', sortable: false, header: 'Name', cell: (row: AppUserPartnerWalletAccessSlim) => (row.appUser?.firstName ?? '') + ' ' + (row.appUser?.lastName  ?? '')},
    {
      columnDef: 'status',
      sortable: false,
      header: 'Status',
      cell: (row: AppUserPartnerWalletAccessSlim) => this.getInviteStatusText(row),
      cellColor: (row: AppUserPartnerWalletAccessSlim) => this.getInviteColor(row),
      icon: (row: AppUserPartnerWalletAccessSlim) => this.getInviteIcon(row),
    },

  ];
  public usersDataSource: ReadOnlyDataSource<AppUserPartnerWalletAccessSlim>;

  getInviteColor(row: AppUserPartnerWalletAccessSlim): string {
    if ( row.isInviteApproved ) {
      return 'green';
    }
    if ( row.isInviteDeclined ) {
      return 'red';
    }
    if ( row.isInvitePending) {
      return 'orange';
    }

    return 'dodgerblue';
  }

  getInviteIcon(row: AppUserPartnerWalletAccessSlim): string {
    if ( row.isInviteApproved ) {
      return 'beenhere';
    }
    if ( row.isInviteDeclined ) {
      return 'front_hand';
    }
    if ( row.isInvitePending) {
      return 'access_time';
    }

    return 'access_time';
  }

  getInviteStatusText(row: AppUserPartnerWalletAccessSlim): string {
    if ( row.isInviteApproved ) {
      return 'Approved';
    }
    if ( row.isInviteDeclined ) {
      return 'Declined';
    }
    if ( row.isInvitePending) {
      return 'Waiting for Data';
    }

    return 'Waiting for Approval';
  }

  getTransactionViewLink = (item: PartnerWalletTransaction): string => 'txn/' + item.id.toString();
  getUserViewLink = (item: AppUser): string => 'user/' + item.id.toString();


  loadUsers = (): Observable<DataListModel<AppUserPartnerWalletAccessSlim>> => this.partnerWalletService.getUsers(this.partnerWalletId);
  brandReferralUrlLink: string|null;

  ngOnInit() {

    this.route.params.subscribe((params: Params) => {

      this.partnerWalletId = null;
      this.isLoading = true;

      const id = parseInt(this.route.snapshot.paramMap.get('id'));
      this.partnerWalletId = id;
      this.loadPartnerWalletData(id);

      this.usersDataSource = new ReadOnlyDataSource<AppUserPartnerWalletAccessSlim>(
        this.loadUsers
      );

    });

  }


  returnBack() {
    this.router.navigate(['..'], {relativeTo: this.route});
  }


  goToEdit() {

    this.dialog.open(EditWalletDialogComponent, {
      data: this.partnerWallet
    })
      .afterClosed()
      .subscribe((result: PartnerWallet) => {

        if ( result == null ) {
          return;
        }

        this.isBusy = true;
        result.id = this.partnerWallet.id;
        this.partnerWalletService.update(result).subscribe(r2 => {
          this.isBusy = false;
          this._toastService.success('Saved');
          this.loadPartnerWalletData(this.partnerWalletId);
        }, err => {
          this.isBusy = false;
          this._toastService.error(err.error.message || err.error || err.message);
          this.loadPartnerWalletData(this.partnerWalletId);
        });

      });

  }

  isAdmin() {
    return this.roleService.hasRoles(['admin']);
  }

  isFinanceManager() {
    return this.roleService.hasRoles(['finance_manager']);
  }

  isComplianceManager() {
    return this.roleService.hasRoles(['compliance_manager']);
  }


  isPartner() {
    return this.roleService.hasRoles(['partner']);
  }

  isPartnerSupport() {
    return this.roleService.hasRoles(['partner_support']);
  }


  isWallet() {
    return this.roleService.hasRoles(['wallet']);
  }

  private loadPartnerWalletData(id: number) {
    this.isLoading = true;
    this.partnerWalletService.get(id).subscribe(data => {
      this.isLoading = false;
      this.partnerWallet = data;

      this.loadTransactions();
      this.loadPendingCardLoads();
      this.loadWalletUsers();
      this.company = this.partnerWallet.company;
      this.getPrevNext(this.partnerWalletId);

      this.isLoading = false;

      this.brandReferralUrlLink = `/brand/${this.partnerWallet.brandReferralCode}`;

      this.partnerWalletService.getLoadInfo(id).subscribe(loadInfo => {
        this.walletLoadInfo = loadInfo;

      });

    });

  }

  isCompliance() {
    return this.roleService.hasRoles(['compliance']);
  }

  transferFunds() {
    this.isBusy = true;
    this.partnerWalletService.getMany(1, 999, 'id', 'asc', null, null, null, null, null).subscribe(data => {
      this.isBusy = false;
      const wallets = data.data;

      this.dialog.open(TransferFundsDialogComponent, {
        data: {
          amount: 0,
          description: 'Transfer',
          sourceWalletId: this.partnerWallet.id,
          destinationWalletId: null,
          wallets,
        }
      })
        .afterClosed()
        .subscribe((result: PartnerWalletTransferFundsModel) => {

          if (result.amount == 0) {
            this._toastService.error('Amount must not be zero');
            return;
          }

          if (!result.description) {
            this._toastService.error('Description must not be empty');
            return;
          }


          this.isBusy = true;

          const amount = result.amount;
          const description = result.description;
          const destinationId = result.destinationWalletId;

          this.partnerWalletService.transferFunds(amount, this.partnerWallet.id, destinationId, description).subscribe(result => {
              this.isBusy = false;
              this._toastService.success('Transfer executed');

              this.loadPartnerWalletData(this.partnerWalletId);

            }, err => {
              this.isBusy = false;
              this._toastService.error(err.error.message || err.error || err.message);
            }
          );

        });


    }, err => {
      this.isBusy = false;
      this._toastService.error(err.error.message || err.message || err.error || err);
    });


  }

  balanceAdjustment() {
    if (!this.isAdmin()) {
      this._toastService.error('Permission denied');
      return;
    }
    this.dialog.open(BalanceAdjustmentDialogComponent, {
      data: {amount: 0, description: 'Balance adjustment by Admin', partnerWalletId: this.partnerWallet.id}
    })
      .afterClosed()
      .subscribe((result: PartnerWalletLoadModel) => {

        if (result.amount == 0) {
          this._toastService.error('Amount must not be zero');
          return;
        }

        if (!result.description) {
          this._toastService.error('Description must not be empty');
          return;
        }


        this.isBusy = true;

        const amount = result.amount;
        const description = result.description;

        this.partnerWalletService.balanceAdjustWalletByAdmin(this.partnerWallet.id, amount, description).subscribe(result => {
            this.isBusy = false;
            this._toastService.success('The wallet\'s balance has been adjusted by ' + amount);

            this.loadPartnerWalletData(this.partnerWalletId);

          }, err => {
            this.isBusy = false;
            this._toastService.error(err.error.message || err.error || err.message);
          }
        );

      });
  }

  loadWallet() {

    if (!this.isAdmin()) {
      this._toastService.error('Permission denied');
      return;
    }

    this.dialog.open(LoadDialogComponent, {
      data: {amount: 0, description: 'Wallet load by Admin', partnerWalletId: this.partnerWallet.id}
    })
      .afterClosed()
      .subscribe((result: PartnerWalletLoadModel) => {

        if (result.amount < 0.01) {
          this._toastService.error('Amount must be larger than zero');
          return;
        }

        if (!result.description) {
          this._toastService.error('Description must not be empty');
          return;
        }


        this.isBusy = true;

        const amount = result.amount;
        const description = result.description;

        this.partnerWalletService.loadWalletByAdmin(this.partnerWallet.id, amount, description).subscribe(result => {
            this.isBusy = false;
            this._toastService.success('The wallet has been loaded by ' + amount);

            this.loadPartnerWalletData(this.partnerWalletId);

          }, err => {
            this.isBusy = false;
            this._toastService.error(err.error.message || err.error || err.message);
          }
        );

      });


  }


  private loadTransactions() {
    this.isLoading = true;
    this.transactionsDataSource.loadData();
  }

  private loadPendingCardLoads() {
    this.isLoading = true;
    this.partnerWalletService.getPendingCardLoads(this.partnerWalletId).subscribe(data => {
      this.pendingCardLoads = data;
      this.isLoading = false;
    });
  }


  getTableFilters() {
    return getTableFilters('partnerWalletTransactionTable');
  }

  getPrevNext(id: number) {
    /*const filters = this.getTableFilters();
    console.log(filters);
    this.partnerWalletService.getPrevNext(filters, id).subscribe(result => {
      this.prevNext = result;
    });*/
  }


  gotoPrev() {
    /*const filters = this.getTableFilters();
    this.partnerWalletService.getPrev(filters, this.partnerWalletId).subscribe(result => {
      this.router.navigate(["/loads/btl/" + result], {queryParams: {displayHistory: "1"}});
    });*/

  }

  gotoNext() {
    /*const filters = this.getTableFilters();
    this.partnerWalletService.getNext(filters, this.partnerWalletId).subscribe(result => {
      this.router.navigate(["/loads/btl/" + result], {queryParams: {displayHistory: "1"}});
    });*/
  }

  uploadPartnerLoadsFile() {

    const dr = this.dialog.open(UploadPartnerLoadsFileDialogComponent, {
      maxWidth: 800,
    });

    dr.componentInstance.upload.subscribe((file: File) => {
        this.isBusy = true;

        this.partnerWalletService.uploadPartnerLoadFile(
          file,
          this.partnerWalletId
        ).subscribe(res => {

          this.isBusy = false;

          if (res.errors.length > 0) {
            const message = 'Warning: ' + res.errors.length + ' errors in the file';

            this._toastService.warn(message);

            this.dialog.open(UploadLoadsFileResultsDialogComponent, {
              data: res.errors,
              maxWidth: 800
            });


          } else {
            this._toastService.success('File has been processed successfully');
          }

          this.loadPartnerWalletData(this.partnerWalletId);
        }, error => {
          this.isBusy = false;
          this._toastService.error(error.message);

        });
      }
    );


  }

  downloadStatement() {

    const date = new Date();
    const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

    const data = new PartnerWalletDownloadStatementModel();
    data.walletId = this.partnerWallet.id;
    data.from = firstDay;
    data.to = lastDay;
    data.format = 'csv';

    this.dialog.open(DownloadStatementDialogComponent, {
      data
    })
      .afterClosed()
      .subscribe((result: PartnerWalletDownloadStatementModel) => {

        if (result.from > result.to) {
          this._toastService.error('from must be before to');
          return;
        }


        this.isBusy = true;

        const from = result.from;
        const to = result.to;
        const format = result.format;

        this.partnerWalletService.downloadStatement(this.partnerWallet.id, from, to, format).subscribe(file => {
          this.isBusy = false;

          FileHelper.saveFile( file );
            // download the file

        }, err => {
          this.isBusy = false;
          this._toastService.error(err.error.message || err.error || err.message);
        }
        );

      });


  }


  uploadDocuments(loadId: number) {
    const dr = this.dialog.open(UploadLoadDocumentsDialogComponent, {
      maxWidth: 800,
    });

    dr.componentInstance.upload.subscribe((file: File) => {
        this.isBusy = true;

        this.partnerWalletService.uploadLoadFileDocuments(
          [file],
          loadId
        ).subscribe(res => {

          this.isBusy = false;


          this._toastService.success('File has been uploaded successfully');

          this.loadPendingCardLoads();
        }, error => {
          this.isBusy = false;
          this._toastService.error(error.message);

        });
      }
    );
  }

  downloadDocument(loadDocId: number) {
    this.partnerWalletService.downloadPartnerLoadDocument( loadDocId ).subscribe(
      result => {
        FileHelper.saveFile( result );
      },
      err =>
        this._toastService.error(err.error.message || err.message || err.error || err)
    );
  }

  deleteDocument(id: number) {

    const that = this;
    const cptnId = id;

    this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: 'Delete document',
        text: 'Are you sure you want to delete this document?'
      },
      minWidth: 350,
    })
      .afterClosed()
      .subscribe(result => {
        if (result == 'ok') {
          that.partnerWalletService.deletePartnerLoadDocument(cptnId).subscribe(_ => {
            this.loadPendingCardLoads();
          });

        }
      });

  }

  onSearch( isInvalid = false ) {
    if ( !isInvalid ) {
      this.transactionsTable.applyFilter();
    }
  }

  clearFilter() {

  }

  inviteUser() {

    this.dialog.open(InviteWalletUserDialogComponent, {
      data: null,
      maxWidth: 400,
    }).afterClosed().subscribe(email => {
      if (email) {
        this.isBusy = true;
        this.partnerWalletService.inviteUser(this.partnerWalletId, email).subscribe(res2 => {
          this._toastService.success(email + ' was invited to this wallet');
          this.loadWalletUsers();
          this.isBusy = false;
          this.isLoading = false;
        }, err => {
          this.isLoading = false;
          this.isBusy = false;
          this._toastService.error(err.error.message || err.error || err.message);
        });
      }
    });

  }

  private loadWalletUsers() {
    this.isLoading = true;
    this.usersDataSource.loadData();
  }


}
